module.exports = __webpack_public_path__ + "static/media/icon_access.33326ca7.png";